import request from "../utils/request";
import {
    SEND_VERIFICATION_CODE_FROM_VERIFY_SECURITY,
    VERIFY_VERIFICATION_CODE_FROM_VERIFY_SECURITY,
    VERIFY_QUESTION_FROM_VERIFY_SECURITY,
    SEND_VERIFICATION_CODE_FROM_SET_SECURITY,
    SET_SECURITY_FROM_SECURITY
} from "@/constants/apis";

export const sendCodeFVS = data => {
    let url = SEND_VERIFICATION_CODE_FROM_VERIFY_SECURITY.replace(
        "<type>",
        data.type
    );
    return request({
        url,
        data
    });
};

export const verifyCodeFVS = data => {
    let url = VERIFY_VERIFICATION_CODE_FROM_VERIFY_SECURITY.replace(
        "<type>",
        data.type
    );
    return request({
        url,
        data
    });
};

export const verifyQa = data => {
    return request({
        url: VERIFY_QUESTION_FROM_VERIFY_SECURITY,
        data
    });
};

export const sendCodeFSS = data => {
    let url = SEND_VERIFICATION_CODE_FROM_SET_SECURITY.replace(
        "<type>",
        data.type
    );
    return request({
        url,
        data
    });
};

export const setSecurity = data => {
    let url = SET_SECURITY_FROM_SECURITY.replace("<type>", data.type);
    return request({
        method: "put",
        url,
        data
    });
};
